export default "__VITE_ASSET__ujbNvlyH__"